var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.75 33.25c-1.816 3.14-4.863 5.25-8.75 5.25s-6.934-2.11-8.75-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28 49c11.598 0 21-9.402 21-21S39.598 7 28 7 7 16.402 7 28s9.402 21 21 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M20.125 25.375a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m15.75 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley3);
export default __webpack_public_path__ + "static/media/smiley3.018c54379136a4f7718ac5a3a0ef1d0f.svg";
export { ForwardRef as ReactComponent };